// Onboarding copy that exists only in the prototype files (not in SPEC.md text or shared/content/lines.ts).
// Verbatim from QO8_FirstHelp, QO9_DoNow, QO10_Lit, except firstNote (app copy after QA 11-01). O6 notes: OB_GOT_YOU in shared.
// Candidates to move into shared/content/lines.ts.
import type { CharId } from '@shared/types';
import { taskShort } from '@shared/rules';

/** O10 flame beat: the buddy's line under "Your first day is lit!" (QO10_Lit `dayOne`). */
export const DAY_ONE: Record<CharId, string> = {
  sunny: "Day one. Don't let it go to your head.",
  margo: "Day one. That's how it starts.",
  arjun: 'Day one. A good start.',
  tavo: 'Day one! The streak starts now!',
};

/** O9 subtitle after "Stuck" made the card smaller (QO9_DoNow). */
export const SMALLER_FINE = 'Smaller is fine. Just that.';

/** O8 "Change the time" cycle for the tomorrow card (QO8_FirstHelp LATER_TIMES). */
export const LATER_TIMES: { time: string; at: number }[] = [
  { time: '9:30 AM', at: 570 }, { time: '1:00 PM', at: 780 }, { time: '7:00 PM', at: 1140 },
];

/** Small caps note on the O10 done card (and Card.note), from the user's own thing: 'CLOSET: FIRST STEP DONE.'
 *  "Pick a time" says TIME PICKED. Not FirstHelp.prep.label (that is the NOW card header). */
export function firstNote(thing: string | null | undefined, timePicked = false): string {
  const t = taskShort(thing || '').replace(/[.!?]+$/, '');
  const what = timePicked ? 'TIME PICKED.' : 'FIRST STEP DONE.';
  return t && t.length <= 32 ? `${t.toUpperCase()}: ${what}` : what;
}

/** O10 "How this works" picture content (QO10_Lit `mini`), illustrative. */
export const TEACH_PLAN = [
  { time: '9:30 AM', title: 'Q3 report: next part' },
  { time: '11:30 AM', title: 'Call the dentist' },
  { time: '6:30 PM', title: 'Walk around the block' },
];
export const TEACH_MORNING = "Morning. What's on today?";
export const TEACH_PUSH = "Time for the report. I'm here.";
export const TEACH_CARD = { label: '9:30 AM · 25 MIN', title: 'Q3 report: write the next part' };

/** O2 "own words": the option the user's words clearly point to, or null. Only plain keywords, and only when exactly one
 *  option matches; anything else stays the user's own words (OnboardingAnswers.changeSaid). The prototype's demo line
 *  "I want to stop being late with work stuff." picks option 1. */
export function matchChange(text: string): string | null {
  const t = text.toLowerCase();
  const rules: [RegExp, string][] = [
    [/\b(work(?!\s*(out|ing out))|job|deadlines?|reports?|projects?|boss|office|meetings?|clients?)\b/, 'Get work done on time'],
    [/\b(bills?|emails?|inbox|calls?|appointments?|errands?|paperwork|taxes|admin|life stuff)\b/, 'Stop putting off life stuff'],
    [/\b(tidy|tidying|clean|cleaning|mess|messy|laundry|dishes|clutter|declutter|vacuum)\b/, 'Keep my place tidy'],
    [/\b(exercise|gym|workouts?|work out|working out|running|jogging|walks?|walking|stretch|stretching|yoga|sports?|fitness|move my body|move more)\b/, 'Move my body more'],
    [/\b(study|studying|learn|learning|class|classes|exams?|homework|course|school|revise|revision|thesis|essay)\b/, 'Study or learn'],
    [/\b(sleep|sleeping|bedtime|go to bed|get to bed|wake|waking|alarm|oversleep|insomnia)\b/, 'Sleep and wake on time'],
  ];
  const hits = rules.filter(([re]) => re.test(t)).map(([, label]) => label);
  return hits.length === 1 ? hits[0] : null;
}
